/// <reference path="../../typings/custom.d.ts" />

// Re-export canvas interactivity functions from GamePage
export {
  disableCanvasInteractivity,
  enableCanvasInteractivity,
  getGameInstance,
  setGameInstance,
} from "../components/Game/Game";

// Export app dimensions for Phaser scenes
import { DEFAULT_SCALE } from './consts/UI';

// Function to calculate app dimensions dynamically
export function calculateAppDimensions() {
  const DEFAULT_WIDTH = window.innerWidth * DEFAULT_SCALE;
  const DEFAULT_HEIGHT = window.innerHeight * DEFAULT_SCALE;
  const IS_VERTICAL_SCREEN = window.innerWidth <= window.innerHeight;
  const scaleRatio = DEFAULT_SCALE;

  let APP_WIDTH = Math.floor(window.innerWidth * scaleRatio);
  let APP_HEIGHT = Math.floor(window.innerHeight * scaleRatio);

  if (!IS_VERTICAL_SCREEN) {
    APP_HEIGHT = DEFAULT_HEIGHT;
    APP_WIDTH = Math.min(3 * DEFAULT_WIDTH, window.innerWidth);

    if (APP_WIDTH > 1.6 * APP_HEIGHT) {
      APP_WIDTH = 1.6 * APP_HEIGHT;
    }
  }

  return { APP_WIDTH, APP_HEIGHT };
}

// Get current app dimensions
export function getAppDimensions() {
  return calculateAppDimensions();
}

// Legacy exports for backward compatibility - now calculated dynamically
export function getAPP_WIDTH() {
  return calculateAppDimensions().APP_WIDTH;
}

export function getAPP_HEIGHT() {
  return calculateAppDimensions().APP_HEIGHT;
}

// Dynamic position config
export function getAPP_POSITION_CONFIG() {
  const { APP_WIDTH, APP_HEIGHT } = calculateAppDimensions();
  return {
    width: APP_WIDTH,
    height: APP_HEIGHT,
  };
}
